import { IonInfiniteScroll } from '@ionic/react'
import { AnimatePresence, motion } from 'framer-motion'

import { useSearchOrdersCount } from '@apps-common/apis/portal/orders/search-orders-count'
import { useSearchOrdersInfinite } from '@apps-common/apis/portal/orders/search-orders-infinite'
import { OrderListCardLg, OrderListCardLgSkeleton } from '@apps-common/apps/portal/pages/orders/components'
import { InfiniteLoader, PullRefresh, RootHeaderButtons } from '@apps-common/components/common'
import { LayoutContainer, LayoutPadding, VertSpacerXl } from '@apps-common/components/layout'
import { PageClearFilterButton, PageResultsCount } from '@apps-common/components/page'
import { GRID_CARDS_VARIANTS } from '@apps-common/config/motion-variants'
import { useNavigation } from '@apps-common/hooks/useNavigation'
import { usePortalOrderFilterStore } from '@apps-common/stores'
import { IOrderListModel } from '@apps-common/types/portal/order'
import { OrdersHeader } from './OrdersHeader'

export const OrdersInfiniteView = () => {
  const { navigateForward } = useNavigation()
  const filter = usePortalOrderFilterStore()

  const {
    data: countData,
    isLoading: countIsLoading,
    isError: countIsError,
    refetch: countRefetch
  } = useSearchOrdersCount({
    model: filter.getSearchParams()
  })

  const { data, isLoading, isFetching, isRefetching, isError, refetch, fetchNextPage } = useSearchOrdersInfinite({
    model: filter.getSearchParams()
  })

  const countLoading = countIsLoading || countIsError
  const loading = isLoading || isRefetching || isError

  return (
    <>
      <OrdersHeader
        icons={<RootHeaderButtons />}
        leftComponent={<PageResultsCount loading={countLoading} count={countData} />}
        rightComponent={<PageClearFilterButton filter={filter} filterKeyWordsFunc={filter.getFilteredByKeywords} callback={filter.clear} />}
        loading={countLoading}
        navigateForward={navigateForward}
        searchCount={countData?.resultCount || -1}
      />
      <LayoutContainer>
        <LayoutPadding topPadding='relative pt-[40px] md:pt-[70px]'>
          <PullRefresh loading={isLoading} callback={refetch} />
          <AnimatePresence>
            <motion.div variants={GRID_CARDS_VARIANTS} initial='initial' animate='animate' className='grid gap-y-[1rem] max-w-[800px]'>
              {loading && Array.from(Array(25).keys()).map((k) => <OrderListCardLgSkeleton key={`orders-list-view-skeleton-${k}`} />)}
              {!loading &&
                data &&
                data?.pages
                  .reduce((acc: IOrderListModel[], curr: IOrderListModel[]) => [...acc, ...curr], [])
                  .map((o: IOrderListModel) => <OrderListCardLg key={`orders-list-view-${o.orderId}`} order={o} />)}
            </motion.div>
          </AnimatePresence>
          <IonInfiniteScroll
            onIonInfinite={async (ev) => {
              await fetchNextPage()
              ev.target.complete()
            }}
          >
            <InfiniteLoader key='orders-infinite-list-infinite-loader' loading={isFetching} />
          </IonInfiniteScroll>
        </LayoutPadding>
        <VertSpacerXl />
      </LayoutContainer>
    </>
  )
}
